import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage'
import { UIInfoSpace } from 'src/types/api'
import icon_skt_default from 'src/assets/images/telecom/icon_skt.png'
import icon_kt_default from 'src/assets/images/telecom/icon_kt.png'
import icon_lg_default from 'src/assets/images/telecom/icon_lg.png'

import icon_skt_active from 'src/assets/images/telecom/icon_skt_on.png'
import icon_kt_active from 'src/assets/images/telecom/icon_kt_on.png'
import icon_lg_active from 'src/assets/images/telecom/icon_lg_on.png'
import styled, { css } from 'styled-components'
import { Link, useSearchParams } from 'react-router-dom'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { useFormContext } from 'react-hook-form'
import { JoinFormType } from 'src/types/react-hook-form'
import React from 'react'

const ShapeLogoAgency = ({
  resetFormItems,
  layoutsInsert,
  blockTelList,
}: Pick<DefaultJoinFormPageProps, 'resetFormItems' | 'blockTelList'> &
  Pick<UIInfoSpace.UIDataType, 'layoutsInsert'>) => {
  const { pCode, fixedTelecom, requestIdPath, form, telecom } = useParamsList()
  const { getValues, setFocus } = useFormContext<JoinFormType>()

  const [searchParams] = useSearchParams()
  const search_params = `?${searchParams.toString()}`
  const hasBlockTel = (blockTelList?.length ?? 0) > 0

  const getIcon = (telecomValue: '0' | '1' | '2', type: 'default' | 'active') => {
    switch (telecomValue) {
      case '0':
        return type === 'default' ? icon_skt_default : icon_skt_active
      case '1':
        return type === 'default' ? icon_kt_default : icon_kt_active
      case '2':
        return type === 'default' ? icon_lg_default : icon_lg_active
      default:
        return ''
    }
  }

  const checkBoxItemsProps = (telecomValue: '0' | '1' | '2') => ({
    to: `/${form}/${pCode}/${requestIdPath}/${telecomValue}${search_params}`,
    $telecom: telecomValue,
    $fixedTelecom: telecomValue === fixedTelecom,
    $isFixedTelecom: !!fixedTelecom,
    $layoutsInsert_agency_actColor: layoutsInsert?.agency?.actColor,
    $disabled: getValues('TranID') !== '' || blockTelList?.includes(telecomValue),
    $active: telecomValue === telecom,
    $defaultIcon: getIcon(telecomValue, 'default'),
    $activeIcon: getIcon(telecomValue, 'active'),
    $gap: hasBlockTel,
    onClick: () => {
      setFocus('PNumber')
      resetFormItems()
    },
    replace: true,
  })

  return (
    <LogoAgency.Container id="agencyTabList" $gap={hasBlockTel}>
      { !blockTelList?.includes('0') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('0')} /> }
      { !blockTelList?.includes('1') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('1')} /> }
      { !blockTelList?.includes('2') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('2')} /> }
    </LogoAgency.Container>
  )
}

export default ShapeLogoAgency

const LogoAgency = {
  Container: styled.div<{
    $gap: boolean
  }>`
    width: 100%;
    height: 50px;
    display: flex;

    ${(props) =>
      props.$gap &&
      css`
        gap: 10px;
      `}
  `,
  CheckBoxItem: styled(Link)<{
    $isFixedTelecom?: boolean
    $fixedTelecom?: boolean
    $disabled?: boolean
    $layoutsInsert_agency_actColor?: string
    $active?: boolean
    $telecom?: '0' | '1' | '2'
    $defaultIcon: string
    $activeIcon: string
    $gap: boolean
  }>`
    position: relative;
    flex: 1;
    padding: 12px 10px;
    border: 1px solid var(--black-20);
    box-sizing: border-box;
    background-color: var(--white);
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    display: flex;

    ${(props) =>
      props.$gap ?
      css`
        border-radius: 12px;
      ` :
      css`
        &:first-child {
          border-radius: 12px 0 0 12px;
        }
        &:last-child {
          border-radius: 0 12px 12px 0;
        }
      `}

    ${(props) => css`
        background: url(${props.$defaultIcon}) no-repeat center/80px;
      `}
    ${(props) =>
      props.$active &&
      css`
        background: url(${props.$activeIcon}) no-repeat center/80px;
        border: 2px solid ${props.$layoutsInsert_agency_actColor || 'var(--brand-40)'};
      `}
    ${({ $isFixedTelecom, $fixedTelecom, $layoutsInsert_agency_actColor, $activeIcon }) =>
      $isFixedTelecom &&
      css`
        ${$fixedTelecom
          ? css`
              border-radius: 0 !important;
              background: url(${$activeIcon}) no-repeat center/80px;
              outline: 2px solid ${$layoutsInsert_agency_actColor || 'var(--brand-40)'};
              border: none;
              pointer-events: none;
            `
          : css`
              display: none;
            `}
      `}

    ${(props) =>
      props.$disabled &&
      css`
        pointer-events: none;
        border: 1px solid var(--black-20);
        &:after {
          content: '';
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: 0.6;
          ${props.$telecom === '0' &&
          css`
            border-radius: 12px 0 0 12px;
          `};
          ${props.$telecom === '1' &&
          css`
            border-radius: 0;
          `};
          ${props.$telecom === '2' &&
          css`
            border-radius: 0 12px 12px 0;
          `};
        }
      `}
  `,
}
